
export const GET_HISTORY_ACCESS_GPS_REQUEST = "GET_HISTORY_ACCESS_GPS_REQUEST";
export const GET_HISTORY_ACCESS_GPS_SUCCESS_FIXED = "GET_HISTORY_ACCESS_GPS_SUCCESS_FIXED";
export const GET_HISTORY_ACCESS_GPS_FAILURE = "GET_HISTORY_ACCESS_GPS_FAILURE";


export const getHistoryAccessGpsRequest = (filters = {}) => ({
    type: GET_HISTORY_ACCESS_GPS_REQUEST,
    payload: {
        filters
    }
});

export const getHistoryAccessGpsSuccess = (history, total) => ({
    type: GET_HISTORY_ACCESS_GPS_SUCCESS_FIXED,
    payload: {
        history,
        total
    }
});

export const getHistoryAccessGpsFailure = err => ({
    type: GET_HISTORY_ACCESS_GPS_FAILURE,
    error: err
});

